module.exports = __webpack_public_path__ + "img/logo.2279a9f3.svg";